import { createReducer } from 'redux-act';

import { IProduct, ICredentials } from './redeem.types';
import { loadRedeemRequest, loadRedeemSuccess, loadRedeemFail } from './redeem.actions';

export interface IRedeemState {
  product: IProduct | null;
  credentials: ICredentials[];
  customLogo?: string;
  redemption: string;
  isLoading: boolean;
  isLoaded: boolean;
}

const initialState = {
  product: null,
  credentials: [],
  redemption: '',
  customLogo: undefined,
  isLoading: false,
  isLoaded: false,
};

const reducer = createReducer<IRedeemState>({}, initialState);

reducer.on(loadRedeemRequest, state => ({
  ...state,
  isLoading: true,
}));

reducer.on(loadRedeemSuccess, (state, { product, credentials, redemption, customLogo }) => ({
  ...state,
  product,
  credentials,
  redemption,
  customLogo,
  isLoading: false,
  isLoaded: true,
}));

reducer.on(loadRedeemFail, state => ({
  ...state,
  isLoading: false,
}));

export default reducer;
